import router from "next/router";
import { CheckBox } from "devextreme-react";

export const BrokerageIdComponent = ({ data }: any) => {
  const handleClick = (data: CounselBrokerage) => {
    void router.replace(`/admin/brokerage/list?counselId=${data.counsel.id}`);
  };

  return (
    <a
      className={`${data.data.counsel?.id ? "cursor-pointer hover:underline text-[#007bff]" : ""}`}
      onClick={() => handleClick(data.data)}
    >
      <div>{data.data.counsel?.id ? `${data.data.counsel.id}` : null}</div>
    </a>
  );
};

export const BrokerageCheckBoxComponent = ({ data }: any, checkBoxHandler: Function) => {
  return (
    <CheckBox
      value={!!data.data.counsel?.id}
      disabled={!!data.data.counsel?.id}
      onValueChanged={e => checkBoxHandler(e, data)}
    />
  );
};
